import { render } from "./myBooking.vue?vue&type=template&id=2822ea49&scoped=true"
import script from "./myBooking.vue?vue&type=script&lang=js"
export * from "./myBooking.vue?vue&type=script&lang=js"

import "./myBooking.vue?vue&type=style&index=0&id=2822ea49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2822ea49"]])

export default __exports__